import { Directive, Input, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[inputMask]'
})
export class InputMaskDirective {

  @Input('inputMaskType') inputMaskType: string;

  private regex = {
    'POSITIVE_DOUBLE': new RegExp(/^[0-9]+(\.[0-9]{0,9}){0,1}$/),
    'POSITIVE_NUMBER': new RegExp(/^\d+$/),
    'DOUBLE_BETWEEN_ZERO_ONE': new RegExp(/^((0{1}(\.[0-9]{0,9}){0,1})|(1{1}))$/),
    'POSITIVE_FLOAT': new RegExp(/^[0-9]+(\.[0-9]{0,2}){0,1}$/),
    'ZERO_ONE': new RegExp(/^[0-1]$/g),
    'PERCENTAGE_POSITIVE_DOUBLE': new RegExp(/^[0-9]+(\.[0-9]{0,9}){0,1}$/),
    'PERCENTAGE_POSITIVE_FLOAT': new RegExp(/^[0-9]{1,3}(\.[0-9]{0,2}){0,1}$/),
    'MONETARY_VALUE': new RegExp(/^[0-9]+(\.[0-9]{0,2}){0,1}$/),
    'NUMBER_LOWER_100': new RegExp(/^(([1]([0-9][0]?))|([0-9]{0,2}))$/),
    'NEGATIVE_DOUBLE': new RegExp(/^-[0-9]+(.[0-9]{0,9}){0,1}$/),
    'NEGATIVE_FLOAT': new RegExp(/^-[0-9]+(.[0-9]{0,2}){0,1}$/),
    'NEGATIVE_NUMBER': new RegExp(/^-\d+$/),
    'NUMBER_BETWEEN_MINUS100_AND_100': new RegExp(/^-?(?:100|[0-9]{1,2})(?:\.[0-9]{1,2})?$/),
    'FLOAT_VALUE': new RegExp(/^(\-){0,1}[0-9]+(.[0-9]{0,2}){0,1}$/),
    'NUMBER': new RegExp(/^[+-]?\d+(\.\d*)?$/)
  };

  private allowedKeys = new RegExp(/^[0-9]?\.?\-?$/g);
  private specialKeys = ['Backspace', 'Delete', 'Tab', 'End', 'Home'];

  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {

    var inputMaskType = (this.inputMaskType) ? this.inputMaskType : "POSITIVE_FLOAT";

    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    //console.log(`String(event.key).match(this.allowedKeys): ${String(event.key).match(this.allowedKeys)}`);
    if (!String(event.key).match(this.allowedKeys)) {
      // console.log('removed event.key: ' + event.key);
      event.preventDefault();
      return false;
    }

    var current: string = this.el.nativeElement.value;
    var next: string = current.concat(event.key);

    // console.log('current ' + current);
    // console.log('next ' + next);
    // console.log('String(next).match(this.regex[inputMaskType]) ' + String(next).match(this.regex[inputMaskType]));
    if (next && !String(next).match(this.regex[inputMaskType])) {
      if (inputMaskType.indexOf('NEGATIVE') < 0 && inputMaskType !== 'NUMBER') {
        event.preventDefault();
        return false;
      } 
    }
  }


}
